// The operator's session, shared across the tools.
//
// Signing in at /admin and then being asked to sign in again at Building
// Directories — with the same password — is the friction the central credential
// was supposed to remove. The token is the same one either way: an admin token
// satisfies every role gate (see `requireRole` in api/_token.js), so a tool can
// simply use it.
//
// sessionStorage rather than localStorage, deliberately: this opens campus
// signage and a public event map, and it should not outlive the browser tab. The
// admin launcher links with target="_self", so the session survives the
// navigation — the spec also copies sessionStorage into a tab opened from a
// same-origin link, which covers a middle-click.
//
// Each tool still keeps its own key for its OWN account (a faculty, a club).
// This is only the fallback for when the operator arrives already signed in.

export const ADMIN_TOKEN_KEY = 'umaps-admin-token';

export function readAdminToken() {
  try { return sessionStorage.getItem(ADMIN_TOKEN_KEY) || ''; } catch { return ''; }
}

export function writeAdminToken(t) {
  try {
    if (t) sessionStorage.setItem(ADMIN_TOKEN_KEY, t);
    else sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch { /* private mode */ }
}

/**
 * The token a tool should start with: its own account first, the operator's
 * session second.
 *
 * Own-account first matters. A faculty signing in on a machine where somebody
 * had been the admin must get their own scope, not inherit every building.
 */
export function initialToken(ownKey) {
  try { return sessionStorage.getItem(ownKey) || readAdminToken() || ''; }
  catch { return ''; }
}

/**
 * Sign out of a tool.
 *
 * Clears the shared admin session too, because when the tool was running on it
 * there is no separate thing to sign out of — leaving it behind would mean
 * "Sign out" put you back on the login screen and the next reload silently
 * signed you in again.
 */
export function clearToken(ownKey) {
  try {
    sessionStorage.removeItem(ownKey);
    sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch { /* private mode */ }
}
